
import React from 'react';
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Switch } from "@/components/ui/switch";
import { Trash2 } from "lucide-react";

interface NewsletterSubscribersTableProps {
  subscribers: any[];
  isProcessing: boolean;
  onToggleStatus: (subscriber: any) => void;
  onDeleteSubscriber: (subscriber: any) => void;
}

const NewsletterSubscribersTable: React.FC<NewsletterSubscribersTableProps> = ({
  subscribers,
  isProcessing,
  onToggleStatus,
  onDeleteSubscriber
}) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric'
    });
  };

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableCaption>List of newsletter subscribers</TableCaption>
        <TableHeader>
          <TableRow>
            <TableHead>Email</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Subscribed Date</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {subscribers.map((subscriber) => (
            <TableRow key={subscriber.id}>
              <TableCell className="font-medium">{subscriber.email}</TableCell>
              <TableCell>{subscriber.first_name || '-'}</TableCell>
              <TableCell>{formatDate(subscriber.created_at)}</TableCell>
              <TableCell>
                <div className="flex items-center space-x-2">
                  <Switch 
                    checked={subscriber.is_active} 
                    onCheckedChange={() => onToggleStatus(subscriber)}
                    disabled={isProcessing}
                  />
                  <Badge 
                    variant={subscriber.is_active ? "default" : "outline"}
                    className={subscriber.is_active ? "bg-green-500" : ""}
                  >
                    {subscriber.is_active ? "Active" : "Inactive"}
                  </Badge>
                </div>
              </TableCell>
              <TableCell>
                <Button 
                  variant="destructive" 
                  size="sm"
                  onClick={() => onDeleteSubscriber(subscriber)}
                  disabled={isProcessing}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default NewsletterSubscribersTable;
